module.exports = __webpack_public_path__ + "static/img/review.b7ff7f6.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/demo/review.png
// module id = B7aC
// module chunks = 36